import replaceAtIdx from 'hero-utils/replaceAtIdx';
export const applyEditPill = (pills, changedPill) => {
    const changedPillIdx = pills.findIndex((pill) => pill.slot === changedPill.slot);
    return replaceAtIdx(pills, changedPill, changedPillIdx);
};
export default applyEditPill;
//# sourceMappingURL=applyEditPill.js.map